module.exports = __webpack_public_path__ + "img/time_orange.4ae810ed.svg";